import * as React from 'react';
import { FormEvent } from 'react';
import { FilterInterface } from '../../Filter/FilterInterface';
import { RangeFilterValueType } from '../../Filter/RangeFilter';
import { RangeFilterValue } from '../../Filter/RangeFilterValue';
import { OptionsType } from './AbstractFilterView';
import { FilterSelect } from './Dropdown/FilterSelect';
import { FilterEvent } from './FilterEvent';
import { AbstractRangeFilterView, RangeFilterProps } from './Range/AbstractRangeFilterView';

export class MinMaxRangeFilter<VALUE_TYPE extends RangeFilterValueType,
    OPTION_TYPE,
    P extends RangeFilterProps<VALUE_TYPE, OPTION_TYPE> = RangeFilterProps<VALUE_TYPE, OPTION_TYPE>>
    extends AbstractRangeFilterView<VALUE_TYPE, OPTION_TYPE, P> {
    constructor(props: Readonly<P>) {
        super(props);
        this.handleMinChange = this.handleMinChange.bind(this);
        this.handleMaxChange = this.handleMaxChange.bind(this);
    }

    protected renderInputInner(
        props: P,
        filter: FilterInterface<VALUE_TYPE>,
        options: OptionsType<OPTION_TYPE>,
        bounds: RangeFilterValue,
        currentValue: RangeFilterValue
    ): JSX.Element | null {
        const minValue = currentValue.min;
        const maxValue = currentValue.max;

        if (options.length >= 2) {
            return <div className='pf-min-max'>
                <FilterSelect value={minValue}
                              onChange={this.handleMinChange}
                              options={options}
                              className="pf-select pf-select-min"/>
                <FilterSelect value={maxValue}
                              onChange={this.handleMaxChange}
                              options={options}
                              className="pf-select pf-select-max"/>
            </div>;
        } else {
            return <div className='pf-min-max'>
                <FilterSelect value={minValue} onChange={this.handleMinChange} options={options}/>
            </div>;
        }
    }

    private getValue(): VALUE_TYPE | undefined {
        const filter = this.props.filter;

        return filter ? filter.value : undefined;
    }

    private handleMinChange(event: FormEvent) {
        const oldValue = this.getValue();
        const valueAsNumber = (new FilterEvent(event)).valueAsNumber;
        const newMin = !isNaN(valueAsNumber) ? valueAsNumber : this.getAvailableMin();
        const newMax = oldValue ? oldValue.max : this.getAvailableMax();

        const filterEvent = new FilterEvent(event, new RangeFilterValue(newMin, newMax) as VALUE_TYPE);
        this.handleChange(filterEvent);
    }

    private handleMaxChange(event: FormEvent) {
        const oldValue = this.getValue();
        const valueAsNumber = (new FilterEvent(event)).valueAsNumber;
        const newMin = oldValue ? oldValue.min : this.getAvailableMin();
        const newMax = !isNaN(valueAsNumber) ? valueAsNumber : this.getAvailableMax();

        const filterEvent = new FilterEvent(event, new RangeFilterValue(newMin, newMax) as VALUE_TYPE);
        this.handleChange(filterEvent);
    }

    private getAvailableMin(): number {
        return this.getOptionsBounds(this.props.options).min;
    }

    private getAvailableMax(): number {
        return this.getOptionsBounds(this.props.options).max;
    }
}
